export function isNotNull(value)
{
    return value !== null && value !== undefined && value !== '' || 'Bitte Feld ausfüllen';
}

export function requiresSelect(value)
{
    return value !== null && value !== undefined && String(value).length > 0 || 'Bitte einen Wert wählen';
}

export function hasMinLength(value, length)
{
    return !value || value.length >= length || 'Bitte mindestens ' + length + ' Zeichen eingeben';
}

export function isEmail(value)
{
    return  /.+@.+\..+/.test(value) || 'Bitte gültige E-Mail Adresse eingeben';
}

export function isNumeric(value)
{
    return !value || /^\d+$/.test(value) || 'Bitte nur Zahlen eingeben';
}